import React, { useState } from "react";
import { Box, Table, TableBody, TableHead, TableCell, TableRow, withStyles, Collapse, Typography, IconButton } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import moment from "moment";
import { EditIconButton, DeleteIconButton } from "./icon-buttons";
import { StyledTableCell, StyledTableRow } from "./";

export default function Category(props) {
	const { category, index } = props;
	const [open, setOpen] = useState(false);

	return (
		<>
			<StyledTableRow hover>
				<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
					<IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
						{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
					</IconButton>
				</StyledTableCell>
				<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{category.name}</StyledTableCell>
				<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{category.description}</StyledTableCell>
				<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
					{moment(category.createdAt).format("DD/MM/YYYY")}
				</StyledTableCell>
				<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
					<EditIconButton tooltipTitle="Editar categoria" onClick={() => props.getCategory(category)} />
					<DeleteIconButton tooltipTitle="Borrar categoria" onClick={() => props.getCategoryId(category._id)} />
				</StyledTableCell>
			</StyledTableRow>
			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box margin={1}>
							<Typography variant="h6" gutterBottom component="div">
								Doctores asociados:
							</Typography>
							<Table size="small" aria-label="purchases">
								<TableHead>
									<TableRow>
										<StyledTableCell2>Rut</StyledTableCell2>
										<StyledTableCell2>Nombre</StyledTableCell2>
										<StyledTableCell2>Apellido</StyledTableCell2>
										<StyledTableCell2>Sexo</StyledTableCell2>
										<StyledTableCell2>Fecha de nacimiento</StyledTableCell2>
										<StyledTableCell2>Teléfono</StyledTableCell2>
										<StyledTableCell2>Teléfono de actividad</StyledTableCell2>
										<StyledTableCell2>Correo</StyledTableCell2>
										<StyledTableCell2>Especialidad 1</StyledTableCell2>
										<StyledTableCell2>Especialidad 2</StyledTableCell2>
										<StyledTableCell2>Especialidad 3</StyledTableCell2>
									</TableRow>
								</TableHead>
								<TableBody>
									{category.doctors.map((doctor) => (
										<TableRow hover key={doctor._id}>
											<StyledTableCell2 style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{doctor.rut.charAt(doctor.rut.length - 2) === "-"
													? doctor.rut
													: `${doctor.rut.slice(0, doctor.rut.length - 1)}-${doctor.rut.slice(doctor.rut.length - 1)}`}
											</StyledTableCell2>
											<StyledTableCell2 style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{doctor.name}</StyledTableCell2>
											<StyledTableCell2 style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{doctor.lastName}</StyledTableCell2>
											<StyledTableCell2 style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{doctor.gender}</StyledTableCell2>
											<StyledTableCell2 style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{doctor.birthdate !== "Invalid date" ? doctor.birthdate : "N/A"}
											</StyledTableCell2>
											<StyledTableCell2 style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{doctor.phone ? doctor.phone : "N/A"}
											</StyledTableCell2>
											<StyledTableCell2 style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{doctor.activityPhone ? doctor.activityPhone : "N/A"}
											</StyledTableCell2>
											<StyledTableCell2 style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{doctor.email ? doctor.email : "N/A"}
											</StyledTableCell2>
											<StyledTableCell2 style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{doctor.specialties[0].name}
											</StyledTableCell2>
											<StyledTableCell2 style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{doctor.specialties[1] ? doctor.specialties[1].name : "N/A"}
											</StyledTableCell2>
											<StyledTableCell2 style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{doctor.specialties[2] ? doctor.specialties[2].name : "N/A"}
											</StyledTableCell2>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
}

const StyledTableCell2 = withStyles((theme) => ({
	head: {
		minWidth: 170,
	},
}))(TableCell);
